// Barra de estado inferior (compacta): empresa activa, bodega operativa, usuario y perfil, ambiente /
// VALIDACIÓN y conexión. Lo que hay que saber de un vistazo, sin ocupar el encabezado.
import { useUbicaciones } from '../api/consultas';
import { useSesion } from '../sesion/SesionContexto';
import { useConexion } from './MenuUsuario';

/** Commit desplegado (UAT: lo fija el build de la imagen `web`); vacío en desarrollo y E2E. */
const VERSION = import.meta.env['VITE_VERSION'] ?? '';

export function BarraEstado({
  validacion,
  rotuloModo = 'VALIDACIÓN',
  alCambiarEmpresa,
}: {
  validacion: boolean;
  rotuloModo?: string;
  alCambiarEmpresa: (id: string) => void;
}) {
  const sesion = useSesion();
  const c = useConexion();
  const ubicaciones = useUbicaciones(sesion.empresa?.id ?? '');
  // Bodega operativa: la primera BODEGA de la empresa (la misma regla que la NV; GAP 20).
  const bodega = (ubicaciones.data ?? []).find((u) => u.tipo === 'BODEGA');
  return (
    <footer className="barra-estado" aria-label="Barra de estado">
      <label
        className="estado-item"
        title="Empresa activa: todo lo que ves y operas es de esta empresa"
      >
        <select
          aria-label="Empresa activa"
          value={sesion.empresa?.id ?? ''}
          onChange={(e) => alCambiarEmpresa(e.target.value)}
        >
          {sesion.empresas.map((e) => (
            <option key={e.id} value={e.id}>
              {e.razon_social}
            </option>
          ))}
        </select>
      </label>
      {bodega && (
        <span className="estado-item" title="Bodega operativa por defecto">
          Bodega <b>{bodega.codigo}</b>
        </span>
      )}
      <span className="estado-item" title="Usuario y perfil en esta empresa">
        <b>{sesion.usuario?.nombre}</b> · {sesion.roles.join(', ') || 'sin rol'}
      </span>
      <span className="espaciador" />
      {validacion ? (
        <span className="estado-item validacion">{rotuloModo}</span>
      ) : (
        c.ambiente &&
        c.ambiente !== 'produccion' && (
          <span className="estado-item">{c.ambiente.toUpperCase()}</span>
        )
      )}
      {VERSION && (
        <span className="estado-item apagado" title="Versión desplegada (commit)">
          {VERSION}
        </span>
      )}
      <span
        className={`estado-item conexion ${c.ok ? 'ok' : 'mal'}`}
        role="status"
        aria-label={`Conexión: ${c.texto}`}
      >
        <span className="punto" aria-hidden /> {c.texto}
      </span>
    </footer>
  );
}
